/* This file was generated by running "node scripts/generateTranslations.js". */
/* Created: 2026-09-10 13:57:07 */

const Keys = {
  authError: 'authError',
  serverError: 'serverError',
  unknownError: 'unknownError',
  merchantRequiredError: 'merchantRequiredError',
  userRequiredError: 'userRequiredError',
  passwordRequiredError: 'passwordRequiredError',
  captchaRequiredError: 'captchaRequiredError'
}; export default Keys;